const OptionalDialog = ({message, positiveBtn, negBtn, positiveAction, negativeAction }) => {


    return ( 
    <div className="optionaldialog flex-column2">
        <pre style={{fontWeight:"bold", color:"white", whiteSpace:"pre-line"}}>{message}</pre>
        <div className="flex-spacearound" style={{width:"100%"}}>
            <button onClick={()=>negativeAction()}>{negBtn}</button>
            <button style={{backgroundColor:"red", color:"white"}} onClick={()=>positiveAction()}>{positiveBtn}</button>
        </div>
    </div> 
    );
}
export default OptionalDialog;